/**
 * @generated SignedSource<<f52f86b13be27625675d915de4ec13b8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedEstimateValueBadge_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShouldShowSimilarSoldItems_viewer" | "useSimilarSoldItemsTracking_viewer">;
  readonly " $fragmentType": "PdpSharedEstimateValueBadge_viewer";
};
export type PdpSharedEstimateValueBadge_viewer$key = {
  readonly " $data"?: PdpSharedEstimateValueBadge_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedEstimateValueBadge_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedEstimateValueBadge_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldShowSimilarSoldItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSimilarSoldItemsTracking_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2ae494927382ed248067d3d751760b5b";

export default node;
